import React from 'react'

export default () => {
  return (
    <div>
      <p className="fa fa-spinner fa-spin"/> One Moment While We Process This...
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Billing/Loading.js